import React, { FC } from 'react';
import { Form, Modal } from 'react-bootstrap';
import styles from './IndicatorModal.module.css';
import { Button } from '../../atoms';
import { CustomDropdown } from '../../molecules';
import { DropdownItem } from '../../molecules/CustomDropdown/CustomDropdown';
import cn from 'classnames';
import { LandscapeIndicatorDetailsResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-indicator-details-response.dto';

interface IndicatorModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  indicators: LandscapeIndicatorDetailsResponseDto[];
  handleSubmit: () => void;
  setSelectedIndicator: React.Dispatch<
    React.SetStateAction<LandscapeIndicatorDetailsResponseDto | undefined>
  >;
}

const IndicatorModal: FC<IndicatorModalProps> = ({
  show,
  setShow,
  indicators,
  handleSubmit,
  setSelectedIndicator,
}) => {
  const items: DropdownItem[] = indicators.map((i) => {
    return {
      label: i.name,
      eventKey: i.id,
    };
  });

  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={cn(styles.modal)}>
        <Modal.Body className={styles.modalBody}>
          <Form.Group>
            <Form.Label>Indicator</Form.Label>
            <CustomDropdown
              initialTitle="Please select an Indicator"
              items={items}
              onSelectOption={(dropdownItem) => {
                const selectedIndicator = indicators.find(
                  (i) => i.id === dropdownItem.eventKey
                );
                setSelectedIndicator(selectedIndicator);
              }}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className={styles.modalButtons}>
          <Button
            onClick={handleSubmit}
            className={styles.button}
            variant="dark"
          >
            Save
          </Button>
          <Button
            className={styles.button}
            variant="light"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default IndicatorModal;
